<template>
  <b-container fluid class="fullContent background-custom pb-5 pb-lg-2">
    <b-row class="title text-center m-0 py-7">
      <b-col class="text-white font-intro">
        <h1>FOResT</h1>
        <h2>Forest Online Resource Tool</h2>
      </b-col>
    </b-row>
    <b-row class="content bg-light mx-auto py-4 px-1 px-sm-3 px-lg-4 rounded mb-3">
      <b-col lg="8">
        <h5 class="pb-3">About FOResT</h5>
        <p>
          If you are planning on harvesting forest products on land in Maine, FOResT (Forest
          Online Resource Tool) makes filing your
          <a href="https://www.maine.gov/dacf/mfs/rules_regs/fons.html" target="_blank" rel="noopener noreferrer">
            Forest Operations Notification (FON)</a>
          to the Maine Forest Service fast and easy – online.
        </p>
        <p>
          As a Landowner, Licensed Forester, Harvester/Operator, or a Landowner’s Designated Agent,
          you can create a user account with credentials unique to you and provide
          basic information about the ownership and the
          planned harvest. For each
          <a href="https://www.maine.gov/dacf/mfs/rules_regs/fons.html" target="_blank" rel="noopener noreferrer">
            Forest Operations Notification</a>
          you file, a unique number is generated that will help you track the wood you harvest –
          all the way from the stump to the mill. You’ll also be able to submit annual Landowner
          Report information online. FOResT will guide you through the process – and once you’ve
          started, you can return any time to complete your notification.
        </p>
      </b-col>
      <b-col lg="4">
        <b-card class="border border-dark text-center px-2 pb-1 px-lg-4">
          <h5 class="pb-2">Need an Account?</h5>
          <p class="p-0">
            It's quick and easy. Please click to create an account so you can easily submit and
            track your Notifications.
          </p>
          <b-button
            :disabled="signedIn"
            variant="outline-primary"
            to="/createAccount"
            class="my-1 w-100 w-lg-auto"
            pill
            aria-label="Create account"
          >
            Create Account
          </b-button>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Home',
  computed: {
    ...mapState('User', {
      signedIn: state => state.signedIn,
    }),
  },
};
</script>
